import React from 'react';
import { cx } from '../ds/classes';
import { LogoMark } from '../site/Logo';

const LEVEL_DELAYS = ['', '[animation-delay:-150ms]', '[animation-delay:-300ms]', '[animation-delay:-450ms]', '[animation-delay:-600ms]'];

/**
 * The screen shown while someone enters the studio: the mark's bars rise once, then a small
 * level meter in `control` keeps moving until the studio is ready. Nothing moves under reduced
 * motion. `detail` says what's loading ("Loading your projects").
 */
export const StudioLoading = ({ detail }) => (
  <div className="fixed inset-0 z-[110] flex flex-col items-center justify-center gap-space-8 p-space-6 bg-base text-ink font-text">
    <LogoMark rise className="w-28 h-28" />
    <div role="status" className="flex flex-col items-center gap-space-2 text-center">
      <span className="font-display text-title-2 text-ink">Warming up the studio…</span>
      {detail && <span className="text-small text-muted">{detail}</span>}
    </div>
    <div aria-hidden="true" className="h-5 flex items-end gap-1">
      {LEVEL_DELAYS.map((delay, i) => (
        <span key={i} className={cx('w-1 h-5 rounded-full bg-control origin-bottom animate-level motion-reduce:animate-none', delay)} />
      ))}
    </div>
  </div>
);
